<template lang='pug' src='./custom-faq-accordion.pug'></template>

<script>
export default {
  props: ['content'],
  data () {
    return {
      isOpen: false
    }
  },
  methods: {
    showContent (i) {
      this.isOpen === i ? this.isOpen = false : this.isOpen = i
    }
  }
}
</script>



// WEBPACK FOOTER //
// custom-faq-accordion.vue?289887cc